module.exports = __webpack_public_path__ + "static/img/04010A_R_2_3_4_20180327_fit.4b62c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/04010A_R_2_3_4_20180327_fit.png
// module id = QRYf
// module chunks = 0